'use strict';

angular.module('atex.art').factory('ArtTemplateStore',
['$q', '$rootScope', 'ArtGenericStore', 'ContentService',

  function($q, $rootScope, ArtGenericStore, ContentService) {
    var initialSyncDeferred = $q.defer();

    var isOnlineFunc = function() {
      return true;
    };

    var serverAdapter = {
      getAll: function() {
        var transferInfo = { id: 'atex.onecms.ContributorToolTemplateList' };

        return ContentService.getContent(transferInfo).then(function(responseInfo) {
          var templateList = atex.onecms.ObjectUtils.getByPath(responseInfo, 'data/aspects/contentData/data/templateList') || [];

          var promises = [];
          templateList.forEach(function(contentId, index) {
            var transferInfo = { id: (contentId.value || contentId).replace('contentid/','') };
            promises.push (ContentService.getContent(transferInfo).then(function(responseInfo) {
                    var result = JSON.parse(responseInfo.data.aspects.contentData.data.data);
                    result.sortOrder = index;

                    // sometimes, in the template the hidden is used as string instead of a boolean
                    // so we normalize the value to a boolean flag in order to have a consistency
                    // checks across the codebase.

                    result.hidden = (result.hidden && typeof result.hidden === 'string' ? result.hidden.toLowerCase() === 'true' : !!result.hidden);
                    return result;
                }
            ));
          });

          return $q.all(promises);
        }).then(null, function (err) {
          var error = atex.onecms.error.Error({
            'severity': atex.onecms.error.severities.CRITICAL,
            'rootCause': err,
            'type': atex.onecms.error.types.SERVER_ERROR,
            'origin': 'ArtTemplateStore',
            'cause': 'Could not read templates from the server'
          });

          console.log(error);
          return $q.reject(error);
        });
      }
    };

    var contentStoreAdapter = {
      syncComplete: function() {
        initialSyncDeferred.resolve();
      },

      getById: function(objectStoreName, id) {
        return initialSyncDeferred.promise.then(function() {
          return ArtGenericStore.getById(objectStoreName, id);
        });
      },

      getAll: function(objectStoreName) {
        return initialSyncDeferred.promise.then(function() {
          return  ArtGenericStore.getAll(objectStoreName);
        });
      },

      put: function(objectStoreName, template) {
        return initialSyncDeferred.promise.then(function() {
          return ArtGenericStore.put(objectStoreName, template);
        });
      },

      putAll: function(objectStoreName, templates) {
        // NOTE: This method is not protected by initialSyncPromise because it's
        // actually used in the sync process itself...

        var promises = [];

        templates.forEach(function(template) {
          promises.push(ArtGenericStore.put(objectStoreName, template));
        });

        return $q.all(promises);
      },

      remove: function(objectStoreName, id) {
        return initialSyncDeferred.promise.then(function() {
          return ArtGenericStore.deleteById(objectStoreName, id);
        });
      }
    };

    var getTemplateFor = function(content, templates) {
      /**
       * This is where we would try to find template information in the data itself.
       * Note that even if the data has template information in it, the template has
       * to exist in the template list for the tool (Contributor Tool).
       */

      var template = undefined;
      var createdWithTemplateId = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/atex.OneCMS/data/createdWithTemplate');

      if (typeof createdWithTemplateId !== 'undefined') {
        template = _.find(templates, function(template) {
          return template.id === createdWithTemplateId;
        });
      }

      /**
       * Regardless of whether or not there is creation template information in the
       * content data, we fallback to the first template (in our list) that operates
       * on the same content / data type.
       */

      if (typeof template === 'undefined') {
        template = _.find(templates, function(template) {
          return typeof template.type !== 'undefined' && template.type === content.data.aspects.contentData.data._type && !template.id.endsWith('.preview');
        });
      }

      return template;
    };

    var delegatingStore = atex.DelegatingStore(atex.act.AngularUtils.applyingQ($q, $rootScope), isOnlineFunc, serverAdapter, contentStoreAdapter, "templates");

    delegatingStore.getTemplateFor = function(article) {
      return this.getAll().then(function(templates) {
        return getTemplateFor(article, templates);
      });
    };

    return delegatingStore;
  }
]);
